import { useRef, useCallback } from 'react';

export const useScrollToElement = (options = { behavior: 'smooth' }) => {
  const elementRef = useRef(null);

  const scrollTo = useCallback(() => {
    if (elementRef.current) {
      elementRef.current.scrollIntoView(options);
    }
  }, [options]);

  return [elementRef, scrollTo];
};